<template>
  <a-table
    :dataSource="dataSource"
    :columns="columns"
    :pagination="pagination"
    @resizeColumn="handleResizeColumn"
    class="mb40"
    style="width: 100%;"
  >
    <template #bodyCell="{record, column}">
      <template v-if="['download'].includes(column.key)">
        <a-button type="link" @click="handleDownload(record)">下载</a-button>
      </template>
    </template>
  </a-table>
</template>
<script>
import { inject, toRefs } from 'vue'
export default {
  setup() {
    return {
      handleResizeColumn: (w, col) => {
        col.width = w
      },
      ...toRefs(inject('initState'))
    }
  }
}
</script>
